const profiles = {
  desktop: {
    name: 'Desktop Web',
    icon: '🖥',
    description: 'Standard desktop browser, 960x540 player',
    playerWidth: 960,
    playerHeight: 540,
    autoplay: false,
    muted: false,
    outstream: false,
    ajaxTimeout: 8000,
    creativeLoadTimeout: 10000,
    ajaxWithCredentials: false,
    showControlsForAdPlayer: true,
    vpaidViewMode: 'normal',
    enableVpaid: true,
    enableSimid: true,
    useHlsJS: true,
  },

  mobile: {
    name: 'Mobile',
    icon: '📱',
    description: 'Smaller viewport, muted autoplay, touch controls',
    playerWidth: 400,
    playerHeight: 225,
    autoplay: true,
    muted: true,
    outstream: false,
    ajaxTimeout: 5000,
    creativeLoadTimeout: 10000,
    ajaxWithCredentials: false,
    showControlsForAdPlayer: true,
    vpaidViewMode: 'normal',
    enableVpaid: true,
    enableSimid: true,
    useHlsJS: true,
  },

  ctv: {
    name: 'CTV / Smart TV',
    icon: '📺',
    description: 'Large 1920x1080 player, autoplay, fullscreen VPAID',
    playerWidth: 1920,
    playerHeight: 1080,
    autoplay: true,
    muted: false,
    outstream: false,
    ajaxTimeout: 10000,
    creativeLoadTimeout: 15000,
    ajaxWithCredentials: false,
    showControlsForAdPlayer: false,
    vpaidViewMode: 'fullscreen',
    enableVpaid: true,
    enableSimid: true,
    useHlsJS: true,
  },

  outstream: {
    name: 'Outstream',
    icon: '▶',
    description: 'Outstream ad mode, 640x360, muted autoplay',
    playerWidth: 640,
    playerHeight: 360,
    autoplay: true,
    muted: true,
    outstream: true,
    ajaxTimeout: 5000,
    creativeLoadTimeout: 8000,
    ajaxWithCredentials: false,
    showControlsForAdPlayer: true,
    vpaidViewMode: 'normal',
    enableVpaid: true,
    enableSimid: true,
    useHlsJS: true,
  },

  custom: {
    name: 'Custom',
    icon: '⚙',
    description: 'Custom overrides on top of a base preset',
    playerWidth: 640,
    playerHeight: 360,
    autoplay: false,
    muted: false,
    outstream: false,
    ajaxTimeout: 8000,
    creativeLoadTimeout: 10000,
    ajaxWithCredentials: false,
    showControlsForAdPlayer: true,
    vpaidViewMode: 'normal',
    enableVpaid: true,
    enableSimid: true,
    useHlsJS: true,
  },
};

const CUSTOM_BASE_OPTIONS = ['desktop', 'mobile', 'ctv', 'outstream'];

const CUSTOM_OVERRIDE_DEFAULTS = {
  base: 'desktop',
  playerWidth: 640,
  playerHeight: 360,
  autoplay: false,
  muted: false,
  outstream: false,
  ajaxWithCredentials: false,
  showControlsForAdPlayer: true,
  vpaidViewMode: 'normal',
  ajaxTimeout: 8000,
  creativeLoadTimeout: 10000,
};

export function normalizeLegacyEnvironmentName(name) {
  if (name === 'mobile-web' || name === 'app') return 'mobile';
  return name;
}

export function getProfile(name) {
  const normalizedName = normalizeLegacyEnvironmentName(name);
  return profiles[normalizedName] || profiles.desktop;
}

export function getProfiles() {
  return { ...profiles };
}

export function getProfileNames() {
  return Object.keys(profiles);
}

export function getCustomBaseOptions() {
  return [...CUSTOM_BASE_OPTIONS];
}

export function getCustomOverrideDefaults() {
  return { ...CUSTOM_OVERRIDE_DEFAULTS };
}

export function buildCustomProfile(customOverrides = {}) {
  const merged = { ...CUSTOM_OVERRIDE_DEFAULTS, ...customOverrides };
  const baseName = CUSTOM_BASE_OPTIONS.includes(merged.base) ? merged.base : CUSTOM_OVERRIDE_DEFAULTS.base;
  const baseProfile = getProfile(baseName);

  return {
    ...baseProfile,
    ...merged,
    name: 'Custom',
    icon: '⚙',
    description: `Custom overrides on top of ${baseProfile.name}`,
  };
}
